"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.array(zod_1.z.object({
    blockId: zod_1.z.number(),
    blockKcOverrideType: zod_1.z.string(),
    kcModelId: zod_1.z.string().nullable(),
    kcMultiplier: zod_1.z.number().nullable(),
    organizationKcModelId: zod_1.z.string().nullable(),
}));
//# sourceMappingURL=kcModelBlockUpdate.js.map